import React, { Component } from 'react';
import axios from "axios/index";



class Search extends Component{
    constructor(props){
        super(props);
        this.state = {
            countries: [],
            categories: [],
            form_category: "",
            form_title: "",
            form_country: "",
            form_tag: "",
            form_offer: "",

        }

        this.handleChangeCategory = this.handleChangeCategory.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeTitle = this.handleChangeTitle.bind(this);
        this.handleChangeOffer = this.handleChangeOffer.bind(this);
        this.handleChangeTag = this.handleChangeTag.bind(this);
        this.handleChangeCountry = this.handleChangeCountry.bind(this);
        axios.get(`https://mportalsystem2.btect.sk/api/getdistricts`)
            .then(res => {
                const data = res.data[0];
                this.setState({ countries: data });
            });

        axios.get(`https://mportalsystem2.btect.sk/api/getcategories`)
            .then(res => {
                const data = res.data[0];
                this.setState({ categories: data });
            });

    }

    createArray(){
        var array = new Array();
        array.push(this.state.form_category);
        array.push(this.state.form_offer);
        array.push(this.state.form_title);
        array.push(this.state.form_tag);
        array.push(this.state.form_country);
        return array;

    }

    handleSubmit(event){
        event.preventDefault();
        if(this.state.form_category == "" && this.state.form_title == "" && this.state.form_country == "" && this.state.form_tag == "" && this.state.form_offer == ""){
            this.props.setSearch();
        }
        else{
            this.createArray();
            this.props.setSearchDefs(this.createArray());
        }
    }



    handleChangeCategory(event) {
        this.setState({form_category: event.target.value});
    }
    handleChangeTitle(event) {
        this.setState({form_title: event.target.value});
    }
    handleChangeCountry(event) {
        this.setState({form_country: event.target.value});
    }
    handleChangeTag(event) {
        this.setState({form_tag: event.target.value});
    }
    handleChangeOffer(event) {
        this.setState({form_offer: event.target.value});
    }



    render(){

        return(
            <div className="search" style={{backgroundImage: "url(https://mportalsystem2.btect.sk/"+ this.props.findImageBySlug("banner")}} >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="nadpis">

                                {this.props.findSlug("nadpis")}
                            </h1>
                            <h4 className="subnadpis">
                                {this.props.findSlug("podnadpis")}
                            </h4>
                            <div className="search-form">
                                <form onSubmit={this.handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <select className='form-select' onChange={this.handleChangeCategory}>
                                                    <option name="category" value="0">Vyberte kategóriu</option>
                                                    {this.state.categories.map(category =>
                                                        <option name="category" value={category.id}>
                                                            {category.title}
                                                        </option>
                                                    )}


                                                </select>
                                            </div>

                                            {/*<div className="form-group">*/}
                                                {/*<input type="text" onChange={this.handleChangeTag} placeholder="Značky alebo kľúčové slová" />*/}
                                            {/*</div>*/}
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <input type="text" onChange={this.handleChangeTitle} placeholder="Hľadať podľa názvu" />
                                            </div>
                                            <div className="form-group">
                                                <select className='form-select' onChange={this.handleChangeOffer}>
                                                    <option>Zobraziť iba akcie?</option>
                                                    <option value="1">Áno</option>
                                                    <option value="0">Nie</option>
                                                </select>
                                            </div>


                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <select className='form-select' onChange={this.handleChangeCountry}>
                                                    <option name="country" value="0">Vyberte kraj</option>
                                                    {this.state.countries.map(country =>
                                                        <option name="country" value={country.id}>
                                                            {country.name}
                                                        </option>
                                                    )}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <button  type="submit" ><i className="fa fa-search" aria-hidden="true"></i>Hľadať</button>
                                                {/*onClick={this.props.setSearch}*/}
                                            </div>

                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Search;